import { PaletteConfigProvider } from 'palette/Config';
import CarouselSectionDesktop from '../components/CarouselSectionDesktop';

function CarouselSectionDesktopSSR(props) {
    return (
        <PaletteConfigProvider
            device="desktop"
            svgPath={App.Config.svgUrl}
            theme="booztlet"
        >
            <CarouselSectionDesktop {...props} />
        </PaletteConfigProvider>
    );
}

export default CarouselSectionDesktopSSR;
